import gql from 'graphql-tag';

export const EVENT_ACTIVITY_NOTE_FRAGMENT = gql`
  fragment DealEventActivityNoteFields on DealEventActivityNoteViewModel {
    id
    content
    createdById
    eventActivityId
    createdDateTime
  }
`;
